import React, { useState } from 'react';
import { db } from '../FirebaseComp/firebase';
import { collection, addDoc } from 'firebase/firestore';
import './screenrequest.css';

function ScreeningRequest() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    screeningType: 'general',
    preferredDate: '',
    preferredTime: '',
    additionalInfo: '',
    agreeTerms: false
  });

  const [submitted, setSubmitted] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };





  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
  };




  const nextStep = () => {
    // Validation for Step 1
    if (currentStep === 1) {
      const { name, email, phone, company } = formData;
      if (!name || !email || !phone || !company) {
        alert("Please fill in all fields before proceeding to the next step.");
        return;
      }
    }
  
    // Validation for Step 2
    if (currentStep === 2) {
      const { preferredDate, preferredTime } = formData;
      if (!preferredDate || !preferredTime) {
        alert("Please select both a preferred date and time before proceeding.");
        return;
      }
    }
  
    setCurrentStep(prev => prev + 1);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const {
      name,
      email,
      phone,
      company,
      screeningType,
      preferredDate,
      preferredTime,
      agreeTerms
    } = formData;
  
    if (
      !name ||
      !email ||
      !phone ||
      !company ||
      !screeningType ||
      !preferredDate ||
      !preferredTime ||
      !agreeTerms
    ) {
      alert("Please fill out all required fields and agree to the terms.");
      return;
    }
  
    try {
      await addDoc(collection(db, "screeningRequest"), formData);
      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting screening request:", error);
      alert("An error occurred while submitting the request. Please try again.");
    }
  };

  return (
    <div className="screening-container">
      <div className="screening-hero">
        <div className="hero-content">

        <h1 className="hero-title animate-fade-in">Professional Eye Care Services</h1>
        <p className="hero-subtitle animate-fade-in-delay">
          Providing advanced Eye care, comprehensive eye exams, and personalized solutions to protect and enhance your eyesight.
        </p>

        </div>
        <div className="hero-wave"></div>
      </div>

      <div className="screening-content">
        {!submitted ? (
          <div className="form-container animate-slide-up">
            <div className="form-header">
              <h2>Request a Screening</h2>
              <div className="progress-steps">
                {[1, 2, 3].map((step) => (
                  <div 
                    key={step} 
                    className={`step ${step === currentStep ? 'active' : ''} ${step < currentStep ? 'completed' : ''}`}
                  >
                    <div className="step-circle">{step}</div>
                    <div className="step-label">
                      {step === 1 && 'Personal Info'}
                      {step === 2 && 'Screening Details'}
                      {step === 3 && 'Review & Submit'}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <form onSubmit={handleSubmit} className="screening-form">
              {currentStep === 1 && (
                <div className="form-step animate-fade-in">
                  <div className="form-group">
                    <label htmlFor="name">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="company">Company/Organization</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="form-input"
                    />
                  </div>
                  <div className="form-actions">
                    <button type="button" onClick={nextStep} className="btn-next">
                      Next <span className="arrow">→</span>
                    </button>
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div className="form-step animate-fade-in">
                  <div className="form-group">
                    <label htmlFor="screeningType">Screening Type</label>
                    <select
                      id="screeningType"
                      name="screeningType"
                      value={formData.screeningType}
                      onChange={handleChange}
                      className="form-input"
                    >
                      <option value="general">General</option>

                    </select>
                  </div>
                  <div className="form-row">
                    <div className="form-group half-width">
                      <label htmlFor="preferredDate">Preferred Date</label>
                      <input
                        type="date"
                        id="preferredDate"
                        name="preferredDate"
                        value={formData.preferredDate}
                        onChange={handleChange}
                        className="form-input"
                      />
                    </div>
                    <div className="form-group half-width">
                      <label htmlFor="preferredTime">Preferred Time</label>
                      <input
                        type="time"
                        id="preferredTime"
                        name="preferredTime"
                        value={formData.preferredTime}
                        onChange={handleChange}
                        className="form-input"
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="additionalInfo">Additional Information</label>
                    <textarea
                      id="additionalInfo"
                      name="additionalInfo"
                      value={formData.additionalInfo}
                      onChange={handleChange}
                      rows="4"
                      className="form-input"
                    ></textarea>
                  </div>
                  <div className="form-actions">
                    <button type="button" onClick={prevStep} className="btn-prev">
                      <span className="arrow">←</span> Back
                    </button>
                    <button type="button" onClick={nextStep} className="btn-next">
                      Next <span className="arrow">→</span>
                    </button>
                  </div>
                </div>
              )}

              {currentStep === 3 && (
                <div className="form-step animate-fade-in">
                  <div className="review-section">
                    <h3>Review Your Information</h3>
                    <div className="review-item">
                      <span className="review-label">Name:</span>
                      <span className="review-value">{formData.name}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Email:</span>
                      <span className="review-value">{formData.email}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Phone:</span>
                      <span className="review-value">{formData.phone || 'Not provided'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Company:</span>
                      <span className="review-value">{formData.company || 'Not provided'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Screening Type:</span>
                      <span className="review-value">
                        {formData.screeningType.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
                      </span>
                    </div>
                    {formData.preferredDate && (
                      <div className="review-item">
                        <span className="review-label">Preferred Date/Time:</span>
                        <span className="review-value">
                          {new Date(formData.preferredDate).toLocaleDateString()} at {formData.preferredTime}
                        </span>
                      </div>
                    )}
                    {formData.additionalInfo && (
                      <div className="review-item">
                        <span className="review-label">Additional Info:</span>
                        <span className="review-value">{formData.additionalInfo}</span>
                      </div>
                    )}
                  </div>
                  <div className="form-group terms-group">
                    <input
                      type="checkbox"
                      id="agreeTerms"
                      name="agreeTerms"
                      checked={formData.agreeTerms}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="agreeTerms">
                      I agree to the terms and conditions and privacy policy
                    </label>
                  </div>
                  <div className="form-actions">
                    <button type="button" onClick={prevStep} className="btn-prev">
                      <span className="arrow">←</span> Back
                    </button>
                    <button type="submit" className="btn-submit">
                      Submit Request
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        ) : (
          <div className="success-message animate-fade-in">
            <div className="success-icon">
              <svg viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
            </div>
            <h2>Thank You for Your Request!</h2>
            <p>We've received your screening request and will contact you within 24 hours to confirm the details.</p>
            <p>A confirmation email has been sent to <strong>{formData.email}</strong>.</p>
            <button 
              className="btn-new-request" 
              onClick={() => {
                setSubmitted(false);
                setCurrentStep(1);
                setFormData({
                  name: '',
                  email: '',
                  phone: '',
                  company: '',
                  screeningType: 'general',
                  preferredDate: '',
                  preferredTime: '',
                  additionalInfo: '',
                  agreeTerms: false
                });
              }}
            >
              Submit Another Request
            </button>
          </div>
        )}

<div className="benefits-section">
  <h2 className="section-title">WHY CHOOSE US ?</h2>
  <div className="benefits-grid">
    
    <div className="benefit-card animate-card">
      <div className="benefit-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
        </svg>
      </div>
    <h3>Expert Team</h3>
     <p>Our qualified optometrists and dedicated staff deliver personalized, high-quality eye care with compassion and precision.</p>

    </div>

    <div className="benefit-card animate-card-delay-1">
      <div className="benefit-icon">
        <svg viewBox="0 0 24 24">
          <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
        </svg>
      </div>
      <h3>Community Development</h3>
      <p>Our projects focus on sustainable Eye health, education, and livelihood improvement.</p>
    </div>

    <div className="benefit-card animate-card-delay-2">
      <div className="benefit-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V8z"/>
        </svg>
      </div>
      <h3>Proven Impact</h3>
      <p>Through our partnerships, thousands have gained access to better Eye care and support services.</p>
    </div>

  </div>
</div>


      </div>
    </div>
  );
}

export default ScreeningRequest;